import React, { useEffect, useState, lazy } from 'react';
export const CTAButton = ({
  variant = 'primary',
  children,
  href = '#precio',
  className = '',
  pulse = true
}: {
  variant?: 'primary' | 'white';
  children: React.ReactNode;
  href?: string;
  className?: string;
  pulse?: boolean;
}) => {
  const baseStyle = 'inline-flex items-center justify-center px-6 sm:px-10 py-[18px] rounded-lg font-bold uppercase text-[15px] sm:text-[18px] transition-all duration-300 text-center';
  const variants = {
    primary: 'bg-biosync text-white hover:bg-biosync-dark shadow-[0_4px_20px_rgba(16,163,127,0.4)]',
    white: 'bg-white text-biosync hover:bg-gray-50 shadow-[0_4px_20px_rgba(255,255,255,0.3)]'
  };
  const pulseClass = pulse ? variant === 'primary' ? 'cta-pulse' : 'cta-pulse-white' : '';
  return <a href={href} className={`${baseStyle} ${variants[variant]} ${pulseClass} ${className}`} data-id="element-240">
      {children}
    </a>;
};
export const TrustSignals = ({
  variant = 'light'
}: {
  variant?: 'light' | 'dark';
}) => {
  const textColor = variant === 'light' ? 'text-white/90' : 'text-biosync-textSec';
  return <div className={`flex flex-wrap justify-center items-center gap-2 sm:gap-4 text-xs sm:text-sm ${textColor} mt-4`} data-id="element-241">
      <span className="flex items-center gap-1" data-id="element-242">
        🛡️ Garantía de satisfacción de 7 días
      </span>
      <span className="hidden sm:inline" data-id="element-243">·</span>
      <span className="flex items-center gap-1" data-id="element-244">🔒 Pago 100% seguro</span>
      <span className="hidden sm:inline" data-id="element-245">·</span>
      <span className="flex items-center gap-1" data-id="element-246">
        💳 Tarjeta · Mercado Pago · Ualá · Transferencia
      </span>
    </div>;
};
export const Countdown = () => {
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 59,
    s: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.s > 0) return {
          ...prev,
          s: prev.s - 1
        };
        if (prev.m > 0) return {
          ...prev,
          m: prev.m - 1,
          s: 59
        };
        if (prev.h > 0) return {
          h: prev.h - 1,
          m: 59,
          s: 59
        };
        return {
          h: 23,
          m: 59,
          s: 59
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (n: number) => n.toString().padStart(2, '0');
  return <div className="flex flex-col items-center" data-id="element-247">
      <div className="flex gap-2 sm:gap-4 mb-2" data-id="element-248">
        <div className="flex flex-col items-center" data-id="element-249">
          <div className="bg-biosync text-white font-bold text-3xl sm:text-5xl rounded-lg p-3 sm:p-4 min-w-[60px] sm:min-w-[90px] text-center" data-id="element-250">
            {format(timeLeft.h)}
          </div>
          <span className="text-white/80 text-xs sm:text-sm mt-2" data-id="element-251">horas</span>
        </div>
        <div className="text-biosync font-bold text-3xl sm:text-5xl py-3 sm:py-4" data-id="element-252">
          :
        </div>
        <div className="flex flex-col items-center" data-id="element-253">
          <div className="bg-biosync text-white font-bold text-3xl sm:text-5xl rounded-lg p-3 sm:p-4 min-w-[60px] sm:min-w-[90px] text-center" data-id="element-254">
            {format(timeLeft.m)}
          </div>
          <span className="text-white/80 text-xs sm:text-sm mt-2" data-id="element-255">minutos</span>
        </div>
        <div className="text-biosync font-bold text-3xl sm:text-5xl py-3 sm:py-4" data-id="element-256">
          :
        </div>
        <div className="flex flex-col items-center" data-id="element-257">
          <div className="bg-biosync text-white font-bold text-3xl sm:text-5xl rounded-lg p-3 sm:p-4 min-w-[60px] sm:min-w-[90px] text-center" data-id="element-258">
            {format(timeLeft.s)}
          </div>
          <span className="text-white/80 text-xs sm:text-sm mt-2" data-id="element-259">
            segundos
          </span>
        </div>
      </div>
    </div>;
};
const PRICE_ITEMS = ['Ebook Principal', 'Módulo 0: System Boot', 'Módulo 1: Bio-Calma', 'Módulo 2: Bio-Control', 'Módulo 3: Bio-Sync', 'Módulo 4: Conexión', 'Módulo 5: Upgrade', 'Bono 1: Kit de Emergencia', 'Bono 2: Guía para Padres', 'Bono 3: Plan 30 Días Autoestima'];
export const PriceCard = ({
  compact = false,
  ctaText = '→ QUIERO EL SISTEMA BIO-SYNC POR $19.990'
}: {
  compact?: boolean;
  ctaText?: string;
}) => {
  return <div className={`bg-white border-2 border-biosync rounded-2xl shadow-[0_8px_30px_rgba(16,163,127,0.15)] mx-auto w-full max-w-lg ${compact ? 'p-4 sm:p-6' : 'p-4 sm:p-8'}`} data-id="element-260">
      {/* Top badge */}
      <div className="flex justify-center mb-3" data-id="element-261">
        <span className="bg-biosync text-white text-[11px] sm:text-sm font-bold uppercase py-1 px-3 rounded-full text-center" data-id="element-262">
          ⭐ SISTEMA COMPLETO BIO-SYNC
        </span>
      </div>

      {/* 2-column header: mockup | title + price */}
      <div className="flex items-center gap-3 sm:gap-4 mb-4" data-id="element-263">
        <img src="https://cdn.magicpatterns.com/uploads/uTx8458UE1jS2Wzxd91X4R/bio_sync_optimized.webp" alt="Pack BIO-SYNC" width={120} height={120} loading="lazy" decoding="async" className="w-20 h-20 sm:w-28 sm:h-28 object-contain shrink-0 drop-shadow-md" data-id="element-264" />
        <div className="flex-1 text-left" data-id="element-265">
          <p className="text-biosync-text font-bold text-base sm:text-lg leading-tight" data-id="element-266">
            Pack BIO-SYNC
          </p>
          <p className="text-biosync-textSec text-xs sm:text-sm line-through" data-id="element-267">
            $85.000 ARS
          </p>
          <p className="text-biosync font-bold text-3xl sm:text-4xl leading-none mt-1" data-id="element-268">
            $19.990
            <span className="text-base sm:text-lg ml-1" data-id="element-269">ARS</span>
          </p>
        </div>
      </div>

      {/* CTA — visible above the fold on mobile */}
      <CTAButton variant="primary" className="w-full mb-3" data-id="element-270">
        {ctaText}
      </CTAButton>

      {/* Trust signals — compact */}
      <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-1 text-[11px] text-biosync-textSec mb-4" data-id="element-271">
        <span data-id="element-272">🔒 Pago seguro</span>
        <span data-id="element-273">⚡ Acceso en 5 min</span>
        <span data-id="element-274">🛡️ Garantía 7 días</span>
        <span data-id="element-275">🇦🇷 Argentina</span>
      </div>

      {/* Compact 2x5 grid of contents */}
      {!compact && <>
          <div className="h-px bg-gray-200 w-full mb-3" data-id="element-276"></div>
          <p className="text-biosync-text font-semibold text-xs sm:text-sm mb-2 text-center" data-id="element-277">
            Todo lo que incluye:
          </p>
          <div className="grid grid-cols-2 gap-x-3 gap-y-1.5 mb-2" data-id="element-278">
            {PRICE_ITEMS.map((item, i) => <div key={i} className="flex items-center gap-1.5" data-id="element-279">
                <span className="text-biosync text-[10px] shrink-0" data-id="element-280">✅</span>
                <span className="text-biosync-textSec text-[11px] sm:text-xs leading-tight" data-id="element-281">
                  {item}
                </span>
              </div>)}
          </div>
          <p className="text-biosync-textSec text-[11px] text-center mt-3" data-id="element-282">
            Pago único · Sin suscripciones mensuales · Acceso de por vida
          </p>
        </>}

      {compact && <>
          <div className="h-px bg-gray-200 w-full mb-3" data-id="element-283"></div>
          <div className="grid grid-cols-2 gap-x-3 gap-y-1.5" data-id="element-284">
            <div className="flex items-center gap-1.5" data-id="element-285">
              <span className="text-biosync text-[10px]" data-id="element-286">✅</span>
              <span className="text-biosync-textSec text-[11px]" data-id="element-287">
                Ebook + 6 Módulos
              </span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-288">
              <span className="text-biosync text-[10px]" data-id="element-289">✅</span>
              <span className="text-biosync-textSec text-[11px]" data-id="element-290">
                3 Bonos Estratégicos
              </span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-291">
              <span className="text-biosync text-[10px]" data-id="element-292">✅</span>
              <span className="text-biosync-textSec text-[11px]" data-id="element-293">
                Acceso inmediato
              </span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-294">
              <span className="text-biosync text-[10px]" data-id="element-295">✅</span>
              <span className="text-biosync-textSec text-[11px]" data-id="element-296">
                Garantía 7 días
              </span>
            </div>
          </div>
        </>}
    </div>;
};